// Thread entity query keys (per §11.4 entity-thread-queries sub-task 1).
//
// `threads.list(limit)` keys the chat history; `threads.detail(id)`
// keys a single thread's messages. The invalidation helper in
// `invalidate.ts` relies on these so cache busts after send/delete/
// title-generation hit the right entries.

import { queryRoots, type QueryKey } from '@/shared/query';

export const threadKeys = {
  all: (): QueryKey => [queryRoots.threads],
  list: (limit: number): QueryKey => [queryRoots.threads, 'list', limit],
  agentList: (agentId: string | null, pageSize: number): QueryKey => [
    queryRoots.threads,
    'list',
    'agent',
    agentId,
    pageSize,
  ],
  promptedAgents: (): QueryKey => [queryRoots.threads, 'promptedAgents'],
  detail: (threadId: string): QueryKey => [
    queryRoots.threads,
    'detail',
    threadId,
  ],
  execution: (threadId: string): QueryKey => [queryRoots.threads, 'execution', threadId],
  sharedWithMe: (limit: number): QueryKey => [queryRoots.threads, 'sharedWithMe', limit],
  viewers: (threadId: string): QueryKey => [queryRoots.threads, 'viewers', threadId],
} as const;
